var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg108Highlighter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.003 512.003",
    style: {
      enableBackground: "new 0 0 512.003 512.003"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M511.901,130.69c-1.065-21.334-10.384-40.983-26.24-55.328l-60.198-54.463c-32.754-29.633-83.561-27.15-113.299,5.574 l-208.875,231.16c-2.146,2.375-3.69,5.231-4.504,8.328L62.692,403.37L4.138,479.617c-4.639,6.041-5.444,14.192-2.077,21.024 c3.367,6.832,10.323,11.158,17.939,11.158h76c5.685,0,11.101-2.419,14.895-6.652l25.693-28.669 c0.068-0.024,0.135-0.049,0.203-0.074l138.387-51.613c2.961-1.104,5.618-2.895,7.754-5.225l48.813-53.252 c7.464-8.143,6.913-20.794-1.229-28.257c-8.144-7.464-20.794-6.913-28.258,1.229l-34.53,37.671L147.223,268.676L341.805,53.331 c14.899-16.396,40.387-17.639,56.821-2.771l60.198,54.463c7.933,7.176,12.594,16.999,13.126,27.66 c0.532,10.66-3.127,20.894-10.316,28.834L364.161,269.39c-7.406,8.195-6.766,20.843,1.43,28.248 c8.196,7.405,20.846,6.766,28.248-1.431l97.459-107.855C505.649,172.503,512.966,152.026,511.901,130.69z M87.068,471.798H60.576 l22.903-29.823l16.553,15.355L87.068,471.798z M231.664,398.326l-97.301,36.29l-30.975-28.732l26.101-99.367L231.664,398.326z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg108Highlighter);
export default __webpack_public_path__ + "static/media/108-highlighter.281c17035af51f84a7b79b625e3efa62.svg";
export { ForwardRef as ReactComponent };